import { Site } from '../../types/Site';

export interface SiteMarkerPropsForComparison {
  site: Site;
  isSelected: boolean;
  onPress: (site: Site) => void;
}

// useSitesWithinRadius replaces `sites` with a freshly-parsed array on every fetch, so a site
// unchanged since the last fetch is still a brand-new object reference -- React.memo's default
// shallow comparison would treat it as changed and re-render every marker on every fetch
// regardless of whether any individual site actually moved. Comparing the specific fields a
// marker actually renders from (not the whole `site` object) lets memoization skip the ~300+
// markers that didn't change, instead of just the handful that did. Shared between
// SiteMarker.native.tsx and SiteMarker.web.tsx rather than imported cross-platform, since a
// runtime (non-type-only) import from the native file would pull react-native-maps into the web
// bundle.
export function siteMarkerPropsAreEqual(
  prev: SiteMarkerPropsForComparison,
  next: SiteMarkerPropsForComparison
): boolean {
  return (
    prev.site.siteId === next.site.siteId &&
    prev.site.coordinate.latitude === next.site.coordinate.latitude &&
    prev.site.coordinate.longitude === next.site.coordinate.longitude &&
    prev.site.source === next.site.source &&
    prev.site.name === next.site.name &&
    prev.isSelected === next.isSelected &&
    prev.onPress === next.onPress
  );
}
